import { useEffect, useState } from "react";

export default function HeroSection() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      className="relative w-full min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/cf156658849f116f04dbb65576bd91ff.jpg"
          alt="Transporte Executivo Premium"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/70 to-black/50"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-black/40"></div>
      </div>

      {/* Silver accent line */}
      <div className="absolute left-0 top-0 h-full w-1 bg-gradient-to-b from-transparent via-slate-400 to-transparent"></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 flex flex-col lg:flex-row items-center justify-between gap-12 pt-24 pb-16">
        {/* Left Content */}
        <div
          className={`flex-1 transition-all duration-1000 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
          }`}
        >
          <div className="flex items-center gap-3 mb-6">
            <div className="h-px w-12 bg-slate-400"></div>
            <span className="text-slate-300 text-sm font-semibold tracking-widest uppercase">
              Transporte Premium
            </span>
          </div>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6">
            Viaje com{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-slate-200 to-slate-400">
              Segurança
            </span>
            <br />e Conforto
          </h1>

          <p className="text-gray-300 text-lg md:text-xl leading-relaxed mb-10 max-w-xl">
            Transporte executivo corporativo para quem valoriza pontualidade,
            bom atendimento e segurança em cada trajeto.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={() => handleNav("#contact")}
              className="flex items-center justify-center gap-2 bg-slate-300 hover:bg-white text-black font-bold px-8 py-4 rounded-md transition-all duration-300 text-base whitespace-nowrap cursor-pointer"
            >
              <i className="ri-car-line"></i>
              Reservar Agora
            </button>
            <button
              onClick={() => handleNav("#fleet")}
              className="flex items-center justify-center gap-2 border border-slate-400/60 hover:border-slate-300 text-slate-300 hover:text-white font-semibold px-8 py-4 rounded-md transition-all duration-300 text-base whitespace-nowrap cursor-pointer"
            >
              <i className="ri-eye-line"></i>
              Ver Nossa Frota
            </button>
          </div>

          {/* Stats */}
          <div className="flex gap-10 mt-14 pt-10 border-t border-white/10">
            {[
              { value: "18", label: "Anos de Experiência" },
              { value: "5.000+", label: "Clientes Satisfeitos" },
              { value: "24/7", label: "Disponibilidade" },
            ].map((stat) => (
              <div key={stat.label}>
                <div className="text-2xl md:text-3xl font-bold text-slate-300">{stat.value}</div>
                <div className="text-gray-400 text-sm mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Right - Feature Cards */}
        <div
          className={`hidden lg:flex flex-col gap-4 w-72 transition-all duration-1000 delay-300 ${
            visible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"
          }`}
        >
          {[
            { icon: "ri-shield-check-line", title: "Segurança Total", desc: "Motoristas treinados e veículos rastreados" },
            { icon: "ri-time-line", title: "Pontualidade", desc: "Comprometimento com horários e rotas" },
            { icon: "ri-vip-crown-line", title: "Experiência VIP", desc: "Atendimento personalizado e exclusivo" },
            { icon: "ri-translate-2", title: "Motoristas Bilíngues", desc: "Atendimento em Português & Inglês para clientes nacionais e internacionais" },
          ].map((card) => (
            <div
              key={card.title}
              className="bg-black/60 border border-slate-500/30 backdrop-blur-sm rounded-lg p-5 flex items-start gap-4 hover:border-slate-400/60 transition-all duration-300"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-slate-400/20 rounded-md flex-shrink-0">
                <i className={`${card.icon} text-slate-300 text-xl`}></i>
              </div>
              <div>
                <div className="text-white font-semibold text-sm">{card.title}</div>
                <div className="text-gray-400 text-xs mt-1 leading-relaxed">{card.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-gray-500 text-xs tracking-widest uppercase">Scroll</span>
        <i className="ri-arrow-down-line text-slate-400 text-lg"></i>
      </div>
    </section>
  );
}
